import { Component, ChangeDetectorRef } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FileUploader, FileItem } from "ng2-file-upload";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { AuthService } from "app/base-module/base-service/auth.service";
import { BaseComponent } from "app/base-module/base-component/base.component";

@Component({
    selector: "app-upload-prev",
    templateUrl: "./upload-prev.component.html",
    styleUrls: ["./upload-prev.component.scss"]
})

export class UploadPrevComponent extends BaseComponent {

    file:any;
    nomeFile:string | null;
    uploader: FileUploader;
    loadingLocal: any;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<UploadPrevComponent>,
        public utiliesService: UtilitesService,
        public authService: AuthService,
        private changeDetector: ChangeDetectorRef
    ) {

    super(dialog, snackBar);
    
    this.nomeFile = null;    

    this.uploader = new FileUploader({
      url: this.utiliesService.urlPrefix + "previdencia/boleta/upload",
      isHTML5: true,
      authToken: "Bearer " + this.authService.getToken()
    });

    this.uploader.onAfterAddingFile = (file) => { 
        file.withCredentials = false; 
    };
    
    this.uploader.onProgressItem = ( fileItem: FileItem, progress: any ) => { 
        this.changeDetector.detectChanges();
    };
    
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      
      this.closeLoading();
      
      if (status == 200){
        var info = JSON.parse(response);
        
        this.showSuccess(info.message);
        
        this.dialogRef.close(info);
      }else{
        var info = JSON.parse(response);
        this.showError(info.message);
        //this.dialogRef.close("cancel");
      }
      
    };
    
  }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    uploadFile(event:any) {    //line 1

        //console.log(event);
        const elem = event.target;  //line 2
        //console.log(elem);
        if (elem.files.length > 0) {     //line 3
        this.file = elem.files[0];
        this.nomeFile = this.file.name;
        }
    }

    isNomeFile(){
        return (this.nomeFile != null);
    }

    startUpload() {
        this.openLoading();
        this.uploader.queue[0].upload();
    }

}
